import React from "react";
import { injectIntl } from "react-intl";
import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import messages from "./my-ebsco-data-reporting-messages";
import SubSection from "../sub-section";
import { NON_EBSCO_URLS } from "../../../../constants";
import "./my-ebsco-data-reporting.scss";

const block = "my-ebsco-data-reporting";
const MyEbscoDataReporting = ({ intl: { formatMessage } }) => {
  return (
    <SubSection
      className={block}
      headerText={formatMessage(messages.myEbscoDataReporting)}
    >
      <ul className={`${block}__list`}>
        <li className={`${block}__list-item`}>
          {formatMessage(messages.generateYourReport)}
        </li>
      </ul>
      <Hyperlink
        href={NON_EBSCO_URLS.ONE_TRUST_URL}
        target="_blank"
        styleType="highlighted"
      >
        {formatMessage(messages.requestMyEbscoReport)}
      </Hyperlink>
    </SubSection>
  );
};

export { MyEbscoDataReporting };
export default injectIntl(MyEbscoDataReporting);
